import { motion } from "framer-motion";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { clinicConfig } from "@/config/clinic";
import { fadeUp, viewport } from "@/lib/reveal";

const FAQS = [
  {
    q: "Where is the clinic located?",
    a: "West Virginia Family Medicine is at 135 W Main Street, Keystone, WV 24868. You'll find directions and a map link in the Visit Us section above.",
  },
  {
    q: "What are your office hours?",
    a: "The office is open Monday through Thursday, 9:00 a.m. to 5:00 p.m. Eastern Time. We're closed Friday through Sunday, though Doc Talk messaging is available any time.",
  },
  {
    q: "How does virtual care through Doc Talk work?",
    a: "Doc Talk is message-based care. You can ask health questions any time and receive answers from a licensed clinician, typically within 24 hours, through secure messaging — no appointment scheduling required.",
  },
  {
    q: "Do I need an appointment for an in-person visit?",
    a: "For in-person primary care we recommend calling ahead so we can set aside time for you. You can also request a visit through the form on this page, which routes you to Doc Talk to finish signing in.",
  },
  {
    q: "How quickly will I hear back on Doc Talk?",
    a: "You can send a message at any hour. A licensed clinician generally responds within 24 hours. For medical emergencies, always call 911.",
  },
  {
    q: "How do I access my health records?",
    a: "Sign in to Doc Talk to securely message your care team, use AI chat for guidance, and view your health information in one place.",
  },
];

export const FAQ = () => {
  return (
    <section id="faq" data-testid="faq-section" className="bg-secondary py-24 md:py-32">
      <div className="mx-auto grid max-w-7xl grid-cols-1 gap-12 px-6 md:px-12 lg:grid-cols-12 lg:gap-16">
        <motion.div variants={fadeUp} initial="hidden" whileInView="visible" viewport={viewport} className="lg:col-span-4">
          <p className="mb-4 text-xs font-bold uppercase tracking-[0.24em] text-accent">Good to know</p>
          <h2 className="font-serif text-4xl font-medium tracking-tight text-foreground md:text-5xl">
            Questions patients ask us.
          </h2>
          <p className="mt-5 text-lg leading-relaxed text-muted-foreground">
            Still unsure? Call{" "}
            <a href={`tel:${clinicConfig.phoneTel}`} className="font-semibold text-primary underline decoration-accent underline-offset-4 dark:text-accent">
              {clinicConfig.phoneDisplay}
            </a>{" "}
            and we'll help.
          </p>
        </motion.div>

        <motion.div variants={fadeUp} initial="hidden" whileInView="visible" viewport={viewport} className="lg:col-span-8">
          <Accordion type="single" collapsible className="w-full">
            {FAQS.map((f, i) => (
              <AccordionItem key={i} value={`item-${i}`} data-testid={`faq-item-${i}`} className="border-b border-border">
                <AccordionTrigger className="py-6 text-left font-serif text-xl font-medium text-foreground hover:no-underline md:text-2xl">
                  {f.q}
                </AccordionTrigger>
                <AccordionContent className="pb-6 text-base leading-relaxed text-muted-foreground">
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </motion.div>
      </div>
    </section>
  );
};

export default FAQ;
